import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "expandArrow",
  "use": "expandArrow-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol viewBox=\"0 0 10 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"expandArrow\">\n<path d=\"M1.66675 5.66797L5.00008 9.0013L8.33341 5.66797\" stroke=\"#007770\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M1.66675 1L5.00008 4.33333L8.33341 1\" stroke=\"#007770\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol